import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../css/BoardForm.css";

const BoardForm = ({ posts, setPosts }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  useEffect(() => {
    if (id) {
      const post = posts.find((post) => post.id === parseInt(id));
      if (post) {
        setTitle(post.title);
        setContent(post.content || "");
      }
    }
  }, [id, posts]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (id) {
      // 수정
      setPosts((prevPosts) =>
        prevPosts.map((post) =>
          post.id === parseInt(id) ? { ...post, title, content } : post
        )
      );
    } else {
      // 새 글 작성
      const newPost = {
        id: posts.length + 1,
        title,
        content,
      };
      setPosts((prevPosts) => [...prevPosts, newPost]);
    }
    navigate("/board");
  };

  return (
    <form onSubmit={handleSubmit} className="board-form">
      <h2>{id ? "게시글 수정" : "새 게시글 작성"}</h2>
      <div>
        <label htmlFor="title">제목</label>
        <input
          type="text"
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
      </div>
      <div>
        <label htmlFor="content">내용</label>
        <textarea
          id="content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          required
        ></textarea>
      </div>
      <div className="button-group">
        <button type="submit">{id ? "수정하기" : "작성하기"}</button>
        <button
          type="button"
          onClick={() => navigate("/board")}
          style={{ backgroundColor: "#777" }}
        >
          취소
        </button>
      </div>
    </form>
  );
};

export default BoardForm;
